import { render, staticRenderFns } from "./AddPrices.vue?vue&type=template&id=77b8322e&scoped=true"
import script from "./AddPrices.vue?vue&type=script&lang=js"
export * from "./AddPrices.vue?vue&type=script&lang=js"
import style0 from "./AddPrices.vue?vue&type=style&index=0&id=77b8322e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b8322e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
